<template>
    <a-modal title="单位信息"
             :width="850"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="onSubmit"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
            <table style="width:80%;height: 380px;" >
                <tr>
                    <th>单位名称：</th>
                    <td>
                        {{supplier.supplierName}}
                    </td>
                    <th>社会统一信用代码：</th>
                    <td>
                        {{supplier.supplierCode}}
                    </td>
                </tr>

                <tr>
                    <th>法定代表人：</th>
                    <td>
                        {{supplier.legalName}}
                    </td>
                    <th>法定代表人身份证：</th>
                    <td>
                        {{supplier.legalIdCard}}
                    </td>
                </tr>

                <tr>
                    <th>联系人：</th>
                    <td>
                        {{supplier.contacts}}
                    </td>
                    <th>联系人手机号：</th>
                    <td>
                        {{supplier.contactsPhone}}
                    </td>
                </tr>

                <!---->
                <tr>
                    <th>办公电话：</th>
                    <td>
                        {{supplier.mobile}}
                    </td>
                    <th>办公地址：</th>
                    <td>
                        {{supplier.completeRegisterAddress}}
                    </td>
                </tr>

                <tr>
                    <th>邮箱：</th>
                    <td>
                        {{supplier.email}}
                    </td>

                    <th>注册时间：</th>
                    <td>
                        {{supplier.foundDate}}
                    </td>
                </tr>

                <tr>
                    <th>注册资本：</th>
                    <td>
                        {{supplier.registerCapital}} &nbsp;万元
                    </td>
                    <th>经营范围：</th>
                    <td>
                        {{supplier.businessScope}}
                    </td>
                </tr>
            </table>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import 'vue-area-linkage/dist/index.css'
    import {pca, pcaa} from 'area-data'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                pca: pca,
                pcaa: pcaa,
                modalLoading: false,
                params: {},
                loading: false,
                supplier: '',
                city: '',
                province: '',
                district: '',
                // selected:[pcaa[86]['110000'],pcaa['110000']['110100'],pcaa['110100']['110101']]
                selected: []
            }
        },
        methods: {
            initInfo(id) {
                let that = this
                this.$http.get('/api/v1/supplier/account/get_supplier_info.json?id=' + id).then(function (res) {
                    that.supplier = res.result.supplier
                })
            },
            onSubmit() {

            },
        }
    };
</script>
<style lang="less" scoped>
    .ant-input {
        width: 300px;
    }

    .fx-form th {
        width: 130px;
    }
    /*table {*/
    /*    height: 400px;*/
    /*}*/
</style>
